import { jsx as _jsx } from "react/jsx-runtime";
import { motion } from 'framer-motion';
import { Box } from '@material-ui/core';
import { varSmallClick, varMediumClick } from './Actions';
export function ButtonAnimate({ mediumClick = false, children, sx, ...other }) {
    return (_jsx(Box, Object.assign({ component: motion.div, whileTap: "tap", whileHover: "hover", variants: mediumClick ? varMediumClick : varSmallClick, sx: { display: 'inline-flex', ...sx } }, other, { children: children }), void 0));
}
//# sourceMappingURL=ButtonAnimate.js.map